/** @override King Living: FullSplitPanelDoubleImageBlockFragment (extended base with colour fields). */

import gql from 'graphql-tag';

import {BaseSplitPanelDoubleImageBlockFragment} from './base-split-panel-double-image-block.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {RichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/rich-text-block.fragment';
import {FullShopTheLookFragment} from '@amblique/contentful/app/contentful/fragments/shop-the-look/full-shop-the-look.fragment';
import {VideoFragment} from '@amblique/contentful/app/contentful/fragments/video/video.fragment';

export const FullSplitPanelDoubleImageBlockFragment = gql`
  ${BaseSplitPanelDoubleImageBlockFragment}
  ${ImageFragment}
  ${RichTextBlockFragment}
  ${FullShopTheLookFragment}
  ${VideoFragment}

  fragment FullSplitPanelDoubleImageBlockFragment on SplitPanelDoubleImageBlock {
    ...BaseSplitPanelDoubleImageBlockFragment

    contentCollection {
      items {
        __typename
        ... on Image {
          ...ImageFragment
        }
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
        ... on Video {
          ...VideoFragment
        }
        ... on ShopTheLook {
          ...FullShopTheLookFragment
        }
      }
    }
    primaryImage {
      ... on Image {
        ...ImageFragment
      }
      ... on Video {
        ...VideoFragment
      }
      ... on ShopTheLook {
        ...FullShopTheLookFragment
      }
    }
  }
`;
